import React, { useState } from 'react';
import PropTypes from 'prop-types';

import CliveRecommendationPanel from '~/components/Clive/CliveRecommendationPanel/CliveRecommendationPanel';
import CliveRecommendationPanelButton from '~/components/Clive/CliveRecommendationPanel/CliveRecommendationPanelButton';

interface CliveAssessmentPanelProps {
  showCliveWarning: boolean;
  hasFnolAiRecommendations: boolean;
  userFirstName: string;
}

const CliveAssessmentPanel: React.FC<CliveAssessmentPanelProps> = ({
  showCliveWarning,
  hasFnolAiRecommendations,
  userFirstName,
}) => {
  const [isDismissed, setIsDismissed] = useState(false);
  const shouldShowCliveWarning = !isDismissed && showCliveWarning;

  const actionComponent = <CliveRecommendationPanelButton text="Dismiss" onClick={() => setIsDismissed(true)} />;

  // Note: the feedback CTA only applies to the AI-recommendations branch — the
  // other branch describes a no-op (no draft to give feedback on).
  const alertBannerNote = hasFnolAiRecommendations
    ? `Hi ${userFirstName}, I've pre-filled some of the fields for you based on the information I was able to extract from the email.
      You can review and edit any of the fields as needed.
      Please make sure to verify all the information carefully before submitting the FNOL to ensure accuracy.
      Once you've reviewed and corrected the form, please use the feedback field at the bottom to note anything Clive got wrong or could improve — the more specific, the better. Your input directly helps us train Clive to be more accurate.`
    : `Hi ${userFirstName}, unfortunately, I wasn't able to complete the email analysis and extract the relevant details.`;

  if (!shouldShowCliveWarning) {
    return null;
  }

  return (
    <CliveRecommendationPanel
      title={"Clive's Assessment"}
      subtitle={alertBannerNote}
      actionComponent={actionComponent}
      avatarType="happy"
    />
  );
};

export default CliveAssessmentPanel;

// PropTypes for backward compatibility (since the original component used PropTypes)
CliveAssessmentPanel.propTypes = {
  showCliveWarning: PropTypes.bool.isRequired,
  hasFnolAiRecommendations: PropTypes.bool.isRequired,
  userFirstName: PropTypes.string.isRequired,
};
